import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AddressBookFilterService } from '../../shared/filter/address-book-filter.service';
import { Store } from '@ngrx/store';
import { AppState } from '../../../store';
import { UntypedFormControl, UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { AddressBooksQuery } from '../../../models/address-books-query';
import { Observable } from 'rxjs';
import { selectAddressBooksTableQuery } from '../../../store/address-books-table/address-books-table.state';
import { FilterAssist } from '../../../models/filter-assist';
import { debounceTime, filter, map, mergeMap, switchMap } from 'rxjs/operators';
import { addressBooksTableAddAssist, addressBooksTableRemoveAssist } from '../../../store/address-books-table/address-books-table.actions';
import { MatOption } from '@angular/material/core';
import { MatAutocompleteTrigger, MatAutocomplete } from '@angular/material/autocomplete';
import { MatInput } from '@angular/material/input';
import { IconComponent } from '../../shared/icon/icon.component';
import { AsyncPipe } from '@angular/common';
import { MatChipGrid, MatChipRow, MatChipRemove, MatChipInput } from '@angular/material/chips';
import { MatFormField } from '@angular/material/form-field';

@Component({
    selector: 'app-address-book-table-filter',
    templateUrl: './address-book-table-filter.component.html',
    styleUrls: ['./address-book-table-filter.component.scss'],
    imports: [ReactiveFormsModule, MatFormField, MatChipGrid, MatChipRow, MatChipRemove, IconComponent, MatInput, MatChipInput, MatAutocompleteTrigger, MatAutocomplete, MatOption, AsyncPipe]
})
export class AddressBookTableFilterComponent implements OnInit {

    @ViewChild('termsInput') termsInput: ElementRef<HTMLInputElement>;

    constructor(private addressBookFilterService: AddressBookFilterService, private store: Store<AppState>) {
    }

    searchForm = new UntypedFormGroup({
        terms: new UntypedFormControl('')
    });

    query$: Observable<AddressBooksQuery> = this.store.select(selectAddressBooksTableQuery);
    activeAssists$: Observable<FilterAssist[]> = this.query$.pipe(
        switchMap((query) => this.addressBookFilterService.activeAssists(query))
    );
    offeredAssists$: Observable<FilterAssist[]> = this.searchForm.valueChanges.pipe(
        debounceTime(200),
        map(form => form.terms),
        filter(terms => typeof terms === 'string'),
        mergeMap(terms => this.addressBookFilterService.autocompleteTerms(terms))
    );

    ngOnInit(): void {
    }

    onAssistSelection(assist: FilterAssist): void {
        this.store.dispatch(addressBooksTableAddAssist({ id: assist.id, parameter: assist.parameter }));
        this.termsInput.nativeElement.value = '';
        this.searchForm.get('terms').setValue('');
    }

    onRemoveAssist(id: string): void {
        this.store.dispatch(addressBooksTableRemoveAssist({ id }));
    }

}
